import { MultiString } from "../../../library-js/i18n/MultiString";
import { Rokojori } from "../Rokojori";
import { ActionType, ActionTypes } from "./data-types/ActionType";
import { ProductType, ProductTypes } from "./data-types/ProductType";
import { TagInfoID, TagInfos } from "./data-types/TagInfo";
import { CreatorID, CreatorInfo, CreatorInfos } from "./data-types/CreatorInfo";
import { ProductCategory } from "./data-types/ProductCategory";
import { SerializedProductsTable } from "./SerializedProductsTable";
import { SerializedProductInfo } from "./SerializedProductInfo";
import { PurchaseOption } from "../assets/AssetInfo";

export class ProductInfo extends SerializedProductInfo
{
  static readonly FREE = 
  { 
    en: "FREE", 
    de:"KOSTENLOS" 
  };

  static getType( info:ProductInfo ):string
  {
    let type = info.types[ 0 ];    

    console.log( "TYPE IS:", type );

    let enumValue =  typeof type !== "string" ? type : ProductType[ type ];
    let ms = ( ProductTypes as any )[ enumValue ];
    
    console.log( "getType", type, enumValue, ProductTypes, ms );

    return Rokojori.locale( ms );
  }

  static getPriceAsNumber( info:ProductInfo )
  {
    return info.usePriceLabel ? 0 : ( info.price[ 0 ] + info.price[ 1 ] / 100 ); 
  }

  static getCreatorInfo( info:ProductInfo ):CreatorInfo
  {
    let type = info.creators[ 0 ];
    let enumValue =  typeof type !== "string" ? type : CreatorInfos[ type ];

    console.log( info, type, enumValue );
    return CreatorInfos[ enumValue ];
  }

  static getCreatorInfoName( info:ProductInfo ):string
  {
    let creatorInfo = ProductInfo.getCreatorInfo( info );
    console.log( "in", creatorInfo );
    return Rokojori.locale( creatorInfo.name );
  }

  static getCreatorInfoLink( info:ProductInfo ):string
  {
    let creatorInfo = ProductInfo.getCreatorInfo( info );
    return Rokojori.locale( creatorInfo.link );
  }

  static getAction( info:ProductInfo ):string
  {
    let ms = ( ActionTypes as any )[ info.actionType ];
    console.log( "locale", ActionTypes,  ms );
    let locale = Rokojori.locale( ms );
    
    return locale;
  }

  static getTags( info:ProductInfo ):string
  {
    let tags:string[] = [];
    
    info.tags.forEach(
      t => 
      {
        if ( t == null )
        {
          return;
        }

        let locale:MultiString = null;

        console.log( "GRABBING TAG:", t );
        let wasMS = false;
        
        if ( typeof t === "string" || typeof t === "number" )
        {
          var stringValue = t as any as "string";
          var tag = typeof t === "number" ? t : ( ( TagInfoID as any )[ stringValue ] as number );
          locale = ( TagInfos as any )[ tag ];          
        }
        else
        { 
          locale = t as MultiString;
          wasMS = true;
        }

        console.log( "locale of tag:", t, wasMS, locale );
        let localeInfo = Rokojori.locale( locale ); 
        tags.push( localeInfo );
      }
    );

    console.log( "TAGS:", info.tags, tags.join( " | " ) );
    return tags.join( " | ");
  }

  static getPrice( info:PurchaseOption ):string
  {
    if ( info.usePriceLabel )
    {
      return Rokojori.locale( info.priceLabel );
    }

    let euros = info.price.gross[ 0 ];
    let cents = info.price.gross[ 1 ];

    return euros + "," + cents + "€";
  }

  static create( types:ProductType[], name:MultiString, imagePath:MultiString, tags:(TagInfoID|MultiString)[], 
                 vendors:CreatorID[], price:[number,number] = null ):ProductInfo
  {
    let info = new ProductInfo();
    info.types = types;
    info.name = name;
    info.imagePath = imagePath;

    info.usePriceLabel = true;
    info.priceLabel = ProductInfo.FREE;
    info.tags = tags;
    info.creators = vendors;

    if ( price )
    {
      info.usePriceLabel = false;
      info.price = price;
    }

    return info;
  }

  static setAction( info:ProductInfo, actionType:ActionType, link:MultiString )
  {
    info.actionType = actionType;
    info.actionLink  = link;
  }
}